export const Heading = ({title}) => {
    return (
        <h1
        className={"font-bold text-[100px] text-gray-800 underline mb-20"}
        >{title}</h1>
    )
}